import React, { useEffect, useRef } from 'react';
import grapesjs from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';

const SimpleTest: React.FC = () => {
  const editorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!editorRef.current) return;

    console.log('SimpleTest: Starting GrapesJS test...');

    try {
      const editor = grapesjs.init({
        container: editorRef.current,
        height: '400px',
        width: 'auto',
        storageManager: false,
        blockManager: {
          appendTo: '.gjs-blocks-c',
          blocks: [
            {
              id: 'section',
              label: 'Section',
              category: 'Basic',
              content: '<section class="section"><h2>Test Section</h2><p>This is a test</p></section>',
            }
          ]
        }
      });

      editor.setComponents(`
        <section class="section">
          <h1>GrapesJS Test</h1>
          <p>If you can see this, GrapesJS is working!</p>
        </section>
      `);

      console.log('SimpleTest: GrapesJS initialized successfully!');
    } catch (error) {
      console.error('SimpleTest: Error initializing GrapesJS:', error);
    }
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2>GrapesJS Simple Test</h2>
      <div ref={editorRef} style={{ border: '1px solid #ccc', height: '400px' }} />
    </div>
  );
};

export default SimpleTest;
